/**
 * Forms Service Layer
 * Centralized AJAX handling for all forms
 */

/**
 * Generic form submission
 */
export async function submitForm(action, formData) {
  try {
    const response = await jQuery.post(hs.ajaxUrl, {
      action: action,
      ...Object.fromEntries(formData),
    });

    return response;
  } catch (error) {
    console.error(`Form submission error for action ${action}:`, error);

    // Try to parse error response
    if (error.responseJSON) {
      return error.responseJSON;
    }

    // Return generic error
    return {
      success: false,
      data: {
        message:
          window.hs?.strings?.generalError || "Er is een fout opgetreden",
      },
    };
  }
}

/**
 * Submit contact form
 */
export async function submitContactForm(formData) {
  return submitForm("submit_contact_form", formData);
}

/**
 * Submit quote form
 */
export async function submitQuoteForm(formData) {
  return submitForm("submit_quote_form", formData);
}

/**
 * Load quote form template
 */
export async function loadQuoteForm(productId) {
  try {
    const response = await jQuery.post(hs.ajaxUrl, {
      action: "load_quote_form",
      product_id: productId,
    });
    return response;
  } catch (error) {
    console.error("Error loading quote form:", error);
    return {
      success: false,
      data: {
        message:
          window.hs?.strings?.quoteLoadError ||
          "Er is een fout opgetreden bij het laden van het formulier",
      },
    };
  }
}

/**
 * Validate form field via AJAX
 */
export async function validateField(fieldName, fieldValue, formType) {
  const formData = new FormData();
  formData.append("action", "validate_form_field");
  formData.append("field_name", fieldName);
  formData.append("field_value", fieldValue);
  formData.append("form_type", formType);

  return submitForm("validate_form_field", formData);
}
